import React from "react";
import { connect } from "react-redux";
import {
  Button,
  TextBox,
  DateBox,
  ValidationGroup,
  ValidationSummary,
  Validator, SelectBox, Popover, List,
} from 'devextreme-react';
import { Tooltip } from "devextreme-react/ui/tooltip";
import styles from "../../../../styles/stylesgenerales";
import { setUserInfo, userRegisterStep, createUserAD } from "../actions";
import LoadingOverlay from "../../../Shared/LoadingOverlay";
import validacion from "../../../../helpers/validaciones";
import AutoCompleteText from './AutoCompleteText';
import Card from './card';
import { isValid } from './validateRut';
import comoBuscar from '../../../../images/como-buscar.png';

class PersonalDataValidate extends React.Component {
  constructor(props) {
    super(props);
    // Birthday
    const birthDay = this.props.UserInfo.BirthDate
      ? new Date(this.props.UserInfo.BirthDate)
      : null;
    if (birthDay) {
      birthDay.setDate(birthDay.getDate() + 1);
    }

    const rutUsuario =
      this.props.UserInfo.Rut ||
      validacion.formatRut(sessionStorage.getItem("rutUsuarioActivacion"), {
        showDots: true,
        showHyphen: true,
      });
    this.state = {
      Birthdate: birthDay,
      showTooltip: false,
      rutUsuario: rutUsuario,
      company: '',
      companyList: [],
      showPhoto: false
    };

    // Paso Uno
    this.validateUser = this.validateUser.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getBirthDate = this.getBirthDate.bind(this);
  }


  getBirthDate = (evento) => {
    if (evento.value) {
      this.setState({ Birthdate: evento.value });
    } else {
      this.setState({ Birthdate: null });
    }
  };
  // Paso Uno
  /**
   * Eventhandler para el evento onChange de todos los objetos
   * del formulario,
   * @param {*} e : Objeto event
   */
  handleChange(e) {
    const ident = typeof e === "object" ? e.element.id : "";
    const personalData = { ...this.props.UserInfo };

    switch (ident) {
      case "firstName": {
        personalData.FirstName = e.value;
        break;
      }
      case "middleName": {
        personalData.MiddleName = e.value ? e.value : "";
        break;
      }
      case "lastName": {
        personalData.LastName = e.value;
        break;
      }
      case "mothersName": {
        personalData.MothersName = e.value;
        break;
      }
      case "telefono": {
        personalData.Phone = e.value;
        break;
      }

      default:
        break;
    }
    /**
     * Almacena los datos del formulario en el store de redux
     */
    this.props.dispatch(setUserInfo(personalData));
  }
  /**
   * Renderiza el formulario de datos personales, en este formulario los
   * datos pre-cargados vienen desde el Store de Redux, desde el reducer
   * UserInfo
   */
  personalData() {
    return (
      <ValidationGroup>
        <center>
          <div className="acceso row">
            {this.props.isLoading && <LoadingOverlay />}
            <div className="tituloLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h4>
                <p style={{ fontSize: 15, paddingTop: 10, fontWeight: "bold" }}>
                  Datos personales
                </p>
              </h4>
              <ValidationSummary />
            </div>
            <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3>
                <p className="text-left">Rut</p>
              </h3>
              <TextBox
                id="rut"
                placeholder="Rut"
                onValueChanged={this.handleChange}
                value={this.state.rutUsuario}
                valueChangeEvent="input"
                disabled={this.state.rutUsuario == null ? false : true}
              >
                <Validator
                  validationRules={[
                    {
                      type: "required",
                      message: "Nombre es requerido",
                    },
                  ]}
                />
              </TextBox>
            </div>
            <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3>
                <p className="text-left">
                  Nombre <span className="label-green-requerido">*</span>
                </p>
              </h3>
              <TextBox
                className="uppercaseText"
                id="firstName"
                placeholder="Nombre"
                onValueChanged={this.handleChange}
                value={this.props.UserInfo.FirstName}
                valueChangeEvent="input"
                maxLength={60}
              >
                <Validator
                  validationRules={[
                    {
                      type: "required",
                      message: "Nombre es requerido",
                    },
                  ]}
                />
              </TextBox>
            </div>

            <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3>
                <p className="text-left">Segundo nombre</p>
              </h3>
              <TextBox
                className="uppercaseText"
                id="middleName"
                placeholder="Segundo nombre"
                onValueChanged={this.handleChange}
                value={this.props.UserInfo.MiddleName}
                valueChangeEvent="input"
                maxLength={60}
              ></TextBox>
            </div>
            <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3>
                <p className="text-left">
                  Apellido Paterno{" "}
                  <span className="label-green-requerido">*</span>
                </p>
              </h3>
              <TextBox
                id="lastName"
                className="uppercaseText"
                placeholder="Apellido Paterno"
                value={this.props.UserInfo.LastName}
                onValueChanged={this.handleChange}
                valueChangeEvent="input"
                maxLength={60}
              >
                <Validator
                  validationRules={[
                    {
                      type: "required",
                      message: "Apellido Paterno es requerido",
                    },
                  ]}
                />
              </TextBox>
            </div>
            <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3>
                <p className="text-left">
                  Apellido Materno{" "}
                  <span className="label-green-requerido">*</span>
                </p>
              </h3>
              <TextBox
                id="mothersName"
                className="uppercaseText"
                placeholder="Apellido Materno"
                onValueChanged={this.handleChange}
                value={this.props.UserInfo.MothersName}
                valueChangeEvent="input"
                maxLength={60}
              >
                <Validator
                  validationRules={[
                    {
                      type: "required",
                      message: "Apellido Materno es requerido",
                    },
                  ]}
                />
              </TextBox>
            </div>
            <div className="componentesLogin text-left col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3>
                <p className="text-left">
                  Fecha Nacimiento{" "}
                  <span className="label-green-requerido">*</span>
                </p>
              </h3>
              <DateBox
                min="1900-01-01"
                id="DayBirth"
                placeholder="día/mes/año"
                onValueChanged={this.getBirthDate}
                displayFormat="dd/MM/yyyy"
                showClearButton
                value={this.state.Birthdate}
                disabled={!!this.props.UserInfo.Birthdate}
                type="date"
                fullWidth
                invalidDateMessage="Fecha Nacimiento inválida"
                onFocusIn={() => this.setState({ showTooltip: true })}
                onFocusOut={() => this.setState({ showTooltip: false })}
              >
                <Validator
                  validationRules={[
                    {
                      type: "required",
                      message: "Fecha Nacimiento es requerido",
                    },
                  ]}
                />
              </DateBox>
              <Tooltip
                visible={this.state.showTooltip}
                hideEvent={'mouseleave'}
                contentRender={() => (
                  <div className="tooltip-custom-content">
                    Formato fecha nacimiento debe ser: día/mes/año
                  </div>
                )}
                position="top"
                target="#DayBirth"
              />

              <h3>Datos de la empresa</h3>
              <span className={`strongText`}>
                Puedes ingresar el RUT de la empresa en la que trabajas para poder tener acceso
                a todas las funcionalidades de ACHS Virtual desde el primer momento.
              </span>
              <h3>
                  <p className="text-left">Rut de la empresa</p>
              </h3>

              <div className={`component`}>
                <AutoCompleteText suggestions={this.state.companyList} company={this.state.company} setCompany={(company) => {this.setState({company})}}/>
              </div>

              <span>
                Si no sabes el RUT de la empresa, puedes ingresalo después cuando inicies sesión en ACHS Virtual.
              </span>

              <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
                {
                  this.state.showPhoto ? (
                      <div className={'cards'}>
                        <div className={'card-gray'}>
                          <div className={'justify-right'}>
                            <button onClick={()=> {
                              this.setState({ showPhoto: false });
                            }} >
                              X
                            </button>
                          </div>
                          <img src={comoBuscar} alt="como buscar google"/>
                          <div className={'justify-center'}>
                            <a className={`greenColor`} href={`https://www.google.com/`} target="_blank">Ir a Google</a>
                          </div>
                        </div>
                      </div>
                  ) : (
                      <div>
                        <button style={styles.fullWidth}
                                onClick={()=> this.setState({ showPhoto: true })}>
                          ¿Como encontrar el RUT de una empresa?
                        </button>
                      </div>
                  )
                }
              </div>

              <Card
                  show={() => {
                    const splitedCompany = this.state.company.split(" - ")
                    const isValidRutCompany = isValid(splitedCompany[0])
                    return this.state.company !== '' && (!isValidRutCompany || splitedCompany.length <= 1)
                  }}
                  linkedCard={true}
                  content={
                    `La empresa registrada no se encuentra afiliada a la ACHS, sin embargo, puedes continuar tu registro sin problemas y tendrás acceso a la sección siniestros y a los cursos abiertos que dicta la ACHS, si tu empresa actual no esta en ACHS Virtual unete en`
                  }
              />

              <Card
                  show={() => {
                    const splitedCompany = this.state.company.split(" - ")
                    const isValidRutCompany = isValid(splitedCompany[0])
                    return this.state.company !== '' && (isValidRutCompany && splitedCompany.length > 1)
                  }}
                  linkedCard={false}
                  content={
                    `Se ha enviado una solicitud a la empresa que ingresaste. Esta solicitud debe ser aprobada por el administrador, sin embargo, puedes continuar tu registro sin problemas y tendrás acceso a la sección de siniestros y los cursos abiertos que dicta la ACHS.`
                  }
              />
            </div>
            {/* {this.props.statusCuenta == 400 ? null : (
              <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <h3>
                  <p className="text-left">
                    Teléfono <span className="label-green-requerido">*</span>
                  </p>
                </h3>
                <TextBox
                  id="telefono"
                  mask="+56\900000000"
                  useMaskedValue
                  placeholder="Teléfono"
                  maxLength={30}
                  onPaste={this.handlePaste}
                  valueChangeEvent="change"
                  onValueChanged={this.handleChange}
                  value={this.props.UserInfo.Phone}
                >
                  <Validator
                    validationRules={[
                      {
                        type: "required",
                        message: "Teléfono es requerido",
                      },
                    ]}
                  />
                </TextBox>
              </div>
            )} */}

            {this.props.isLoading && <LoadingOverlay />}

            <div
              className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
              style={{ textAlign: "center" }}
            >
              {/* {this.props.statusCuenta == 400 ? (
                <Button
                  style={styles.fullWidth}
                  text="Siguiente"
                  type="success"
                  onClick={() => this.redireccionPantallaFinalizarRegistro()}
                />
              ) : (
                <Button
                  style={styles.fullWidth}
                  text="Finalizar Registro"
                  type="success"
                  onClick={this.validateUser}
                />
              )} */}
              <Button
                style={styles.fullWidth}
                text="Siguiente"
                type="success"
                onClick={(e) => {
                  const result = e.validationGroup.validate().isValid;
                  const userInfo2 = { ...this.props.UserInfo };
                  const rutCompany = this.state.company.split(" - ")
                  userInfo2.BirthDate = this.state.Birthdate;
                  userInfo2.Rut = this.state.rutUsuario;
                  userInfo2.companyRut = this.state.company === '' ? this.state.company : rutCompany[0]
                  this.props.dispatch(setUserInfo(userInfo2));
                  result && this.redireccionPantallaFinalizarRegistro();
                }}
              />
            </div>
          </div>
        </center>
      </ValidationGroup>
    );
  }

  /**
   * @description Seetear la redireccion al nuevo componente de finalizar registro
   */
  redireccionPantallaFinalizarRegistro = () => {
    const steps = {
      stepOne: false,
      stepTwo: false,
      stepThree: false,
      stepFour: false, // Setea la redirección a la siguiente pantalla CrearPassword
      stepSeven: true,
      stepSuccess: false,
    };
    this.props.dispatch(userRegisterStep(steps));
  };

  /**
   * Metodo para validar los datos del formulario antes de enviarlos al backend
   * y proceder a crear el usuario.
   * @param {*} params : Datos del formulario formulario principal
   */
  validateUser(params) {
    //Metodo de DevExtreme para validar el formulario programaticamente
    const result = params.validationGroup.validate();

    /**
     * Si el formulario es valido, envia los datos al backend para crear el usuario
     */
    if (result.isValid) {
      // Paso 5
      const steps = {
        stepOne: false,
        stepTwo: false,
        stepThree: false,
        stepFour: true, // Setea la redirección a la siguiente pantalla CrearPassword
        stepSuccess: false,
      };
      const personalData = { ...this.props.UserInfo };

      if (
        personalData.Birthdate === null ||
        personalData.Birthdate === undefined
      ) {
        personalData.Birthdate = this.state.Birthdate;

        //Guarda la info del formulario en Redux Store en UserInfo.
        this.props.dispatch(setUserInfo(personalData));
      }
      //Sí el usuario no es temporal, lo va  acrear al AD
      if (personalData.TempBD === false) {
        // se crea una String random como password y se crea el usuario AD
        personalData.UserType = "emailAddress";
        personalData.Password = Math.random().toString(36).substring(2);

        //Ejecuta Action para crear usuario en Azure Active Directory
        this.props.dispatch(createUserAD(personalData));
      } else {
        this.props.dispatch(userRegisterStep(steps));
      }
    }
  }

  render() {
    return <div className="zero container-fluid">{this.personalData()}</div>;
  }
}

/**
 * Devuelve la info del usuario ingresada en la pantalla anterior, junto con la info
 *  de los serivicios de cotizaciones y Datos personales del Middleware ACHS
 * desde el store de redux
 */
const mapStateToProps = (state) => ({
  UserInfo: state.userRegister.UserInfo,
  isLoading: state.global.isLoading || state.recover.isLoading,
  statusCuenta: state.recover.statusCuenta,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonalDataValidate);
